export const SET_PROJECTS_FOLDER_RENAME_DIALOG_IS_OPEN = 'SET_PROJECTS_FOLDER_RENAME_DIALOG_IS_OPEN'
export const SET_PROJECTS_FOLDER_RENAME_PENDING = 'SET_PROJECTS_FOLDER_RENAME_PENDING'
export const SET_PROJECTS_FOLDER_TO_RENAME = 'SET_PROJECTS_FOLDER_TO_RENAME'
